export const canAddNewFilters = ({ renderedFilters, selectOptions }) => {
  if (
    renderedFilters?.length === selectOptions?.length - 1 ||
    renderedFilters.includes('all')
  ) {
    return false;
  }
  return true;
};
